// import React, { useState, useRef, useEffect } from "react";
// import DropDownIcon from "../../../Assets/Images/CreateBatch/icon-dropdown-menu.png";
// import "./FieldsComponent.css";
// export default function DropDownMultipleSelection({
//   width,
//   label,
//   selected,
//   setSelected,
//   options,
//   customWidth,
//   customTop,
//   isRequired,
//   style,
//   className,
//   showSelectAll, // New prop to control the visibility of "Select All"
// }) {
//   const [isActive, setIsActive] = useState(false);
//   const dropdownRef = useRef(null);

//   useEffect(() => {
//     function handleClickOutside(event) {
//       if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
//         setIsActive(false);
//       }
//     }
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//     };
//   }, [dropdownRef]);

//   const handleClick = (option) => {
//     const isSelected = selected.includes(option.id);
//     if (isSelected) {
//       setSelected(selected.filter((id) => id !== option.id));
//     } else {
//       setSelected([...selected, option.id]);
//     }
//   };

//   const handleSelectAll = () => {
//     if (selected.length === options.length) {
//       setSelected([]); // Unselect all
//     } else {
//       setSelected(options.map((option) => option.id)); // Select all
//     }
//   };

//   return (
//     <div
//       className={`dropdown-CB ${className}`}
//       style={{ width, ...style }}
//       ref={dropdownRef}
//     >
//       <label className="dropdown-CB-label">
//         {label}
//         {isRequired && <span>*</span>}
//       </label>
//       <div className="dropdown-btn" onClick={() => setIsActive(!isActive)}>
//         {selected.length > 0
//           ? options
//               .filter((option) => selected.includes(option.id))
//               .map((option) => option.label)
//               .join(",")
//           : "Select options"}
//           {/* {"Select Options"} */}
//         <img src={DropDownIcon} alt="dropdown-icon" />
//       </div>
//       {isActive && (
//         <div
//           className="dropdown-content-CBV2"
//           style={{ width: customWidth, top: customTop }}
//         >
//           {showSelectAll && (
//             <div className="dropdown-item-CBV2">
//               <input
//                 type="checkbox"
//                 checked={selected.length === options.length}
//                 onChange={handleSelectAll}
//               />
//               <label style={{ marginLeft: "8px" }} onClick={handleSelectAll}>
//                 Select All
//               </label>
//             </div>
//           )}
//           {options.map((option) => (
//             <div key={option.id} className="dropdown-item-CBV2">
//               <input
//                 type="checkbox"
//                 checked={selected.includes(option.id)}
//                 onChange={() => handleClick(option)}
//               />
//               <label style={{ marginLeft: "8px" }} onClick={() => handleClick(option)}>
//                 {option.label}
//               </label>
//             </div>
//           ))}
//         </div>
//       )}
//     </div>
//   );
// }








// import React, { useState, useRef, useEffect } from "react";
// import DropDownIcon from "../../../Assets/Images/CreateBatch/icon-dropdown-menu.png";
// import "./FieldsComponent.css";

// export default function DropDownMultipleSelection({
//   width,
//   label,
//   selected,
//   setSelected,
//   options,
//   customWidth,
//   customTop,
//   isRequired,
//   style,
//   className,
//   showSelectAll, // New prop to control the visibility of "Select All"
// }) {
//   const [isActive, setIsActive] = useState(false);
//   const dropdownRef = useRef(null);

//   useEffect(() => {
//     function handleClickOutside(event) {
//       if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
//         setIsActive(false);
//       }
//     }
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//     };
//   }, [dropdownRef]);

//   const handleClick = (option) => {
//     const isSelected = selected.includes(option.id);
//     if (isSelected) {
//       setSelected(selected.filter((id) => id !== option.id));
//     } else {
//       setSelected([...selected, option.id]);
//     }
//   };

//   const handleSelectAll = () => {
//     if (selected.length === options.length) {
//       setSelected([]); // Unselect all
//     } else {
//       setSelected(options.map((option) => option.id)); // Select all
//     }
//   };

//   return (
//     <div
//       className={`dropdown-CB ${className}`}
//       style={{ width, ...style }}
//       ref={dropdownRef}
//     >
//       <label className="dropdown-CB-label">
//         {label}
//         {isRequired && <span>*</span>}
//       </label>
//       <div className="dropdown-btn" onClick={() => setIsActive(!isActive)}>
//         <div className="selected-options" style={{ maxWidth: "200px", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
//           {selected.length > 0
//             ? options
//                 .filter((option) => selected.includes(option.id))
//                 .map((option) => option.label)
//                 .join(", ")
//             : "Select options"}

//         </div>
//         <img src={DropDownIcon} alt="dropdown-icon" />
//       </div>
//       {isActive && (
//         <div
//           className="dropdown-content-CBV2"
//           style={{ width: customWidth, top: customTop }}
//         >
//           {showSelectAll && (
//             <div className="dropdown-item-CBV2">
//               <input
//                 type="checkbox"
//                 checked={selected.length === options.length}
//                 onChange={handleSelectAll}
//               />
//               <label style={{ marginLeft: "8px" }} onClick={handleSelectAll}>
//                 Select All
//               </label>
//             </div>
//           )}
//           {options.map((option) => (
//             <div key={option.id} className="dropdown-item-CBV2">
//               <input
//                 type="checkbox"
//                 checked={selected.includes(option.id)}
//                 onChange={() => handleClick(option)}
//               />
//               <label
//                 style={{ marginLeft: "8px" }}
//                 onClick={() => handleClick(option)}
//               >
//                 {option.label}
//               </label>
//             </div>
//           ))}
//         </div>
//       )}
//     </div>
//   );
// }

import React, { useState, useRef, useEffect } from "react";
import DropDownIcon from "../../../Assets/Images/CreateBatch/icon-dropdown-menu.png";
import "./FieldsComponent.css";

export default function DropDownMultipleSelection2({
  width,
  label,
  selected,
  setSelected,
  options,
  customWidth,
  customTop,
  isRequired,
  style,
  className,
  showSelectAll, // New prop to control the visibility of "Select All"
  onDropdownClose, // Callback to trigger when dropdown closes
}) {
  const [isActive, setIsActive] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsActive(false);
        if (onDropdownClose) onDropdownClose(); // Trigger API call after dropdown closes
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [dropdownRef, onDropdownClose]);

  const handleClick = (option) => {
    const isSelected = selected.includes(option.id);
    if (isSelected) {
      setSelected(selected.filter((id) => id !== option.id));
    } else {
      setSelected([...selected, option.id]);
    }
  };

  const handleSelectAll = () => {
    if (selected.length === options.length) {
      setSelected([]); // Unselect all
    } else {
      setSelected(options.map((option) => option.id)); // Select all
    }
  };

  return (
    <div
      className={`dropdown-CB ${className}`}
      style={{ width, ...style }}
     
    >
      <label className="dropdown-CB-label">
        {label}
        {isRequired && <span>*</span>}
      </label>
      <div className="dropdown-btn" onClick={() => setIsActive(!isActive)}>
        <div
          className="selected-options"
          style={{
            maxWidth: "200px",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            color: selected.length === 0 ? "grey" : "#6A6A6A", // Change color conditionally
          }}
        >
          {selected.length > 0
            ? options
                .filter((option) => selected.includes(option.id))
                .map((option) => option.label)
                .join(", ")
            : "Select options"}
        </div>
        <img src={DropDownIcon} alt="dropdown-icon" />
      </div>
      {isActive && (
        <div
          className="dropdown-content-CBV2"
          style={{ width: customWidth, top: customTop }}
          ref={dropdownRef}
        >
          {showSelectAll && (
            <div className="dropdown-item-CBV2">
              <input
                type="checkbox"
                checked={selected.length === options.length}
                onChange={handleSelectAll}
              />
              <label style={{ marginLeft: "8px" }} onClick={handleSelectAll}>
                Select All
              </label>
            </div>
          )}
          {options.map((option) => (
            <div key={option.id} className="dropdown-item-CBV2">
              <input
                type="checkbox"
                checked={selected.includes(option.id)}
                onChange={() => handleClick(option)}
              />
              <label
                style={{ marginLeft: "8px" }}
                onClick={() => handleClick(option)}
              >
                {option.label}
              </label>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}














// import React, { useState, useRef, useEffect } from "react";
// import DropDownIcon from "../../../Assets/Images/CreateBatch/icon-dropdown-menu.png";
// import "./FieldsComponent.css";

// export default function DropDownMultipleSelection2({
//   width,
//   label,
//   selected,
//   setSelected,
//   options, // The full list of options
//   customWidth,
//   customTop,
//   isRequired,
//   style,
//   className,
//   showSelectAll,
//   onDropdownClose,
// }) {
//   const [isActive, setIsActive] = useState(false); // Dropdown visibility state
//   const dropdownRef = useRef(null); // Reference to the dropdown content
//   const buttonRef = useRef(null); // Reference to the dropdown toggle button

//   // Ensure full list of options is always displayed
//   useEffect(() => {
//     console.log("Selected state:", selected); // Log the selected options
//     console.log("Options list:", options); // Log the full options list
//   }, [selected, options]);

//   // Close dropdown when clicking outside, but ignore clicks inside the dropdown
//   useEffect(() => {
//     function handleClickOutside(event) {
//       if (
//         dropdownRef.current &&
//         !dropdownRef.current.contains(event.target) && // Click is outside the dropdown content
//         buttonRef.current && 
//         !buttonRef.current.contains(event.target) // Click is outside the button
//       ) {
//         setIsActive(false); // Close dropdown if clicked outside
//         if (onDropdownClose) onDropdownClose();
//       }
//     }

//     document.addEventListener("mousedown", handleClickOutside);
//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//     };
//   }, [dropdownRef, buttonRef, onDropdownClose]);

//   // Handle option selection
//   const handleClick = (option, event) => {
//     event.stopPropagation(); // Prevent the click from bubbling up
//     const isSelected = selected.includes(option.id);
//     if (isSelected) {
//       setSelected((prevSelected) => prevSelected.filter((id) => id !== option.id));
//     } else {
//       setSelected((prevSelected) => [...prevSelected, option.id]);
//     }
//     setIsActive(true); // Keep dropdown open after selection
//   };

//   // Handle "Select All" option
//   const handleSelectAll = (event) => {
//     event.stopPropagation(); // Prevent the click from bubbling up
//     if (selected.length === options.length) {
//       setSelected([]); // Deselect all
//     } else {
//       setSelected(options.map((option) => option.id)); // Select all
//     }
//     setIsActive(true); // Keep dropdown open after selecting all
//   };

//   return (
//     <div className={`dropdown-CB ${className}`} style={{ width, ...style }}>
//       <label className="dropdown-CB-label">
//         {label}
//         {isRequired && <span>*</span>}
//       </label>
//       <div
//         className="dropdown-btn"
//         ref={buttonRef} // Ref for the button
//         onClick={() => {
//           setIsActive(!isActive); // Toggle dropdown open/close state
//         }}
//       >
//         <div
//           className="selected-options"
//           style={{
//             maxWidth: "200px",
//             whiteSpace: "nowrap",
//             overflow: "hidden",
//             textOverflow: "ellipsis",
//             color: selected.length === 0 ? "grey" : "black",
//           }}
//         >
//           {selected.length > 0
//             ? `${selected.length} option(s) selected`
//             : "Select options"}
//         </div>
//         <img src={DropDownIcon} alt="dropdown-icon" />
//       </div>
//       {isActive && (
//         <div
//           className="dropdown-content-CBV2"
//           style={{ width: customWidth, top: customTop }}
//           ref={dropdownRef} // Ref for the dropdown content
//           onClick={(e) => e.stopPropagation()} // Prevent dropdown from closing on content click
//         >
//           {showSelectAll && (
//             <div className="dropdown-item-CBV2" onClick={handleSelectAll}>
//               <input
//                 type="checkbox"
//                 checked={selected.length === options.length}
//                 onChange={handleSelectAll}
//               />
//               <label style={{ marginLeft: "8px" }}>
//                 Select All
//               </label>
//             </div>
//           )}
//           {/* Render all options */}
//           {options.map((option) => (
//             <div key={option.id} className="dropdown-item-CBV2" onClick={(e) => handleClick(option, e)}>
//               <input
//                 type="checkbox"
//                 checked={selected.includes(option.id)} // Mark selected options
//                 onChange={(e) => handleClick(option, e)} // Handle selection
//               />
//               <label style={{ marginLeft: "8px" }}>
//                 {option.label}
//               </label>
//             </div>
//           ))}
//         </div>
//       )}
//     </div>
//   );
// }